module.exports = "<textarea [name]=\"question.rows[0].id\"\n          rows=\"4\"\n          [(ngModel)]=\"question.rows[0].value\"\n          (keyup)=\"checkAnswered()\"\n          (blur)=\"modified.emit(null)\"></textarea>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/survey/text-question/text-question.component.html
// module id = 295
// module chunks = 1